import {DOCUMENT_STATUS} from "../constants";

const getPrettyStatus = (status) => DOCUMENT_STATUS[status]?.textValue || status;

export default getPrettyStatus;
